import { BoxProps, Button, Container, Typography } from '@mui/material';
import { useConnection } from 'modules/auth/hooks/useConnection';
import { useWalletConnectModal } from 'modules/auth/hooks/useConnectionModal';
import { QueryLoading } from 'modules/common/components/QueryLoading';
import { useTranslation } from 'modules/i18n';
import { ReactNode } from 'react';
import { translation } from './translation';
import { ScreenCardContent } from 'modules/withdrawal/components/Withdraw/components/ScreenCard/ScreenCardContent';

interface IConnectionGuardProps {
  children: ReactNode;
  /**
   * Instantly show connect modal if user is not connected
   * @default true
   */
  showConnectModal?: boolean;
  sx?: BoxProps['sx'];
}

export function ConnectionGuard({
  children,
}: IConnectionGuardProps): JSX.Element {
  const { isConnected, isLoading } = useConnection();
  const { isOpened, onOpen } = useWalletConnectModal();
  const { keys, t } = useTranslation(translation);

  if (isConnected) {
    return <>{children}</>;
  }

  if (!isConnected && isLoading) {
    return <QueryLoading isAbsolute />;
  }

  return (
    <Container maxWidth="sm">
      <ScreenCardContent>
        <Typography variant="h6" textAlign="center" gutterBottom>
          {t(keys.title)}
        </Typography>

        <Typography textAlign="center" color="text.secondary" marginBottom={4}>
          {t(keys.description)}
        </Typography>

        <Button
          onClick={onOpen}
          disabled={isOpened}
          size="large"
          variant="contained"
          fullWidth
        >
          {t(keys.connect)}
        </Button>
      </ScreenCardContent>
    </Container>
  );
}
